import CartImageComponent from "../imgs/CartImage";
import ImageComponent from "../imgs/Image";
import { STATE } from "../../classes/Enum";
import { normaliseVariantName, decrementCartItem } from "../../helper/addToCart";
import { useEffect, useRef, useState } from "react";
import { useCart } from "../Context";
import { getDisplayPrice } from "../../helper/products";
import ProductName from "../ProductName";


const CartItems = ({fetchProduct, minimised, isMobile}) => {
    const {cart, setCart} = useCart();
    const scrollRef = useRef(null);
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const update = () => {
        setCanScrollUp(el.scrollTop > 0);
        setCanScrollDown(el.scrollTop + el.clientHeight < el.scrollHeight);
        };

        update(); // initial check
        el.addEventListener("scroll", update);

        return () => el.removeEventListener("scroll", update);
    }, [cart]); // re-check when cart changes


    const cartItemDetails = (cartItem, productId) => {
        let product = fetchProduct(productId);
        let price = getDisplayPrice(product.price);
        let appliedPrice = cartItem.appliedPrice ? getDisplayPrice(cartItem.appliedPrice) : undefined;

        if (product.type === STATE.CARD) {
            price = getDisplayPrice(product.conditionQuantities?.[cartItem.variant]?.[cartItem.condition]?.price);
        }

        const hasDiscount = appliedPrice < getDisplayPrice(fetchProduct(productId).price);

        return <div>
            <div className='row'>
                <h3 className={hasDiscount ? 'strikethrough' : ''}> ${price} </h3>
                <h3>{hasDiscount && '>>'}</h3>
                <h3 style={{'color':'yellow'}}>{hasDiscount && appliedPrice}&nbsp;</h3>
                <h3> · Qty {cartItem.count}</h3>
            </div>
        </div>
    }

    return (
    <div className="cart-item-container">
        {canScrollUp && <div className="scroll-indicator top"> <img src="assets/imgs/up arrows.png"></img> </div>}
        {canScrollDown && <div className="scroll-indicator bottom"> <img src="assets/imgs/down arrows.png"></img> </div>}

        <div ref={scrollRef} className={`hide-scrollbar cart-items ${minimised ? 'minimised' : ''}`}>
        {cart.map((cartItem, index) => {
            const { productId, condition, variant} = cartItem;
            const item = fetchProduct(productId);
            
            return (
            <div className={`cart-item ${minimised ? 'min' : ''}`} key={index}
            style ={!minimised ? {width: '100vw'} : {}}>
                <div className={`cart-item-module ${minimised ? 'min' : ''}`}>
                    <CartImageComponent item={item}/>
                    <div className={`cart-item-text ${minimised ? 'min' : ''}`}>
                        <h1>
                          <ProductName name={item.name} type={item.type} useFullName stacked />
                        </h1>
                        { !minimised && <h2> {item.type} {item.subtext ? '| ' + item.subtext : null} </h2>}
                        <h2 className="row">
                            {`${condition ? condition : ""}${variant ? " · " + normaliseVariantName(variant) : ""}`}
                        </h2>
                        <div>{cartItemDetails(cartItem, productId)}</div>
                    </div>
                    {!minimised && (
                        <button className="remove-button tertiary-active" onClick={() => decrementCartItem(cart, setCart, index)}>
                            Remove
                        </button>
                    )}
                <div className='cart-background'>
                {!minimised && (
                  <h1 className="cart-background-name">
                    <ProductName name={item.name} type={item.type} useFullName />
                  </h1>
                )}
                { !minimised && <div className='cart-non-card'>
                    <ImageComponent imageSrc={`/imgs/${item.setId}-high.png`}/>
                    </div>}
                </div>
                </div>
            </div>
            );
        })}
        </div>
    </div>)
}

export default CartItems